import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ProjectTemplate } from './projects.types';
import { RelatedToType } from '@shared/enums';

@Injectable({ providedIn: 'root' })
export class ProjectTemplateService {
  constructor(private readonly httpClient: HttpClient) {}

  get<T>(relatedTo?: RelatedToType | string): Observable<ProjectTemplate<T>[]> {
    return this.httpClient
      .get<{ templates: ProjectTemplate<T>[] }>(`project_templates${relatedTo ? `?related_to_type=${relatedTo}` : ''}`)
      .pipe(
        map((response) => {
          return response.templates;
        }),
      );
  }

  getById(id: number): Observable<ProjectTemplate<any>> {
    return this.httpClient.get<any>(`project_templates/${id}`).pipe(map(({ project_template }) => project_template));
  }

  create<T>(projectTemplate: ProjectTemplate<T>): Observable<ProjectTemplate<T>> {
    return this.httpClient
      .post<{ project_template: ProjectTemplate<T> }>(`project_templates`, {
        project_template: projectTemplate,
      })
      .pipe(map(({ project_template }) => project_template));
  }

  update<T>(projectTemplate: ProjectTemplate<T>): Observable<ProjectTemplate<T>> {
    return this.httpClient
      .put<{ project_template: ProjectTemplate<T> }>(`project_templates/${projectTemplate.id}`, {
        project_template: projectTemplate,
      })
      .pipe(map(({ project_template }) => project_template));
  }
}
